import { compose } from 'redux';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import { firestoreConnect } from 'react-redux-firebase';
import { getAPlayerAction } from '../store/actions';
import Players from '../components/players/Players';


const mapDispatchToProps = ({
    getAPlayer: getAPlayerAction
});


const mapStateToProps = (state, ownProps) => {
    const id = ownProps.match.params.id ? ownProps.match.params.id : '981a14ba-2752-4f41-b854-75114e401082';

    return {
        players: state.firestoreData.ordered.gamePlayers,
        id: id
    }
}

const PlayersContainer =  withRouter(compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => ([
        { 
            collection: 'games' ,
            doc: props.id,
            subcollections: [{ collection: 'players' }],
            storeAs: 'gamePlayers'
        }
      ]))
)(Players));

export default PlayersContainer;